<template>
    <v-dialog v-model="show" max-width="500">
        <v-card>
            <v-card-title class="headline primary primarytext--text">
                {{resource.lastname}}
                <v-btn icon @click="show = false" class="ml-auto"><v-icon color="primarytext">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text v-if="position">
                <GmapMap
                    :center="position"
                    :zoom="7"
                    map-type-id="terrain"
                    style="width: 100%; height: 300px"
                    id="googlemap"
                >
                 <GmapMarker
                    :position="position"
                    
                />
                <!-- :icon="{ url: '/api/image/get?type=Logo&id=1',  scaledSize: {width: 32, height: 32} }" -->
                </GmapMap>

                <div v-if="resource.address">
                    {{resource.address}}<br>
                    {{resource.city}}<br>
                </div>
                    
            </v-card-text>

            <v-card-actions>
                <v-btn class="zoezi-button-thin" color="primary" outlined @click="navigate">{{$translate('Navigate here')}}</v-btn>
                <v-spacer></v-spacer>

                <zoezi-button :text="$translate('Close')" @click="show = false" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'

import Vue from 'vue'
export default {
    name: 'zoezi-map-dialog',

    props: ['value', 'resource'],

    components: {
        GmapMap: VueGoogleMaps.Map,
        GmapMarker: VueGoogleMaps.Marker
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.show = value;
            }
        },
        show(show) {
            if (show != this.value) {
                this.$emit('input', show);
            }
        }
    },


    data: () => ({
        show: false
    }),

    computed: {
        position() {
            let p = this.resource?.position?.split(',');
            return p ? {lat: Number(p[0]), lng: Number(p[1])} : null;
        }
    },

    methods: {
        navigate() {
            let url = `https://www.google.com/maps/dir/?api=1&destination=${this.position.lat}%2C${this.position.lng}&travelmode=driving`
            window.open(url, '_blank')
        }
    },

    created() {
        Vue.use(VueGoogleMaps, {
            load: {
                key: 'AIzaSyAkUAkjyqsYAb-FCtpUY7WdetIQUv1-slQ',
            }
        })
    }
}
</script>